import { IApplicationState } from '../../types/redux';

export function selectTransportAccessibilityInfrastructure(state: IApplicationState) {
  return state.infrastructure.transportAccessibilityInfrastructure;
}
